import React from 'react';
import './Quickmold.css';
import moldVideo from '../../../video/Quickmold1.mp4'; 

const Quickmold = () => {
  return (
    <div className="quickmold-container">
      <div className="quickmold-text">
        <h1>Quick Mold Changing from Side</h1>
        <p>
          Mold changes are made quick and convenient, as they can be changed from the side.
          Particularly advantageous for factories with height limitations, ensuring efficient mold
          changes without the need for overhead space.
        </p>
      </div>

      <div className="quickmold-video">
        <video controls autoPlay muted loop>
          <source src={moldVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default Quickmold;
